const $ = jQuery;

const Template = new (class {
  constructor() {
    $(() => this.onDocumentReady());
  }

  onDocumentReady() {}
})();

window.Template = Template;
